import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Paper, Chip, } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { ArrowLeft, ChevronLeft, ChevronsLeft, User } from 'react-feather';
import { useDispatch } from 'react-redux'
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Toastmessage from '../../components/Toast';
import { logout } from '../../features/auth/AuthSlice';
import { useSelector } from 'react-redux';
import { authApi } from '../../api/api';
import dayjs from 'dayjs';

export default function FirmDetails() {

    const location = useLocation();
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const userID = useSelector((state_id) => state_id.auth.id);
    const token = useSelector((state_id) => state_id.auth.token);
    const { firmId } = location.state || {};
    const [formData, setFormData] = useState({
        userName: '',
        owner: '',
        email: '',
        contactNumber: '',
        designation: '',
        registerNumber: '',
        address: '',
        city: '',
        state: '',
        country: '',
        profile_image: '',
        zipCode: '',
        duration: '',
        selectedPlan: '',
        // subscription_start_date: new Date(),
        PaymentStatus: '',
        paymentType: '',
        paymentDate: null,
        paymentTransaction: '',
        accountEmail: '',
        password: '',
        confirmPassword: '',
        subscription_exp_date: '',
        subscription_start_date: '',
        isActive: false,
    });


    const handleClickEdit = () => {
        navigate('/EditFirm', { state: { firmId: firmId } });
    };
    const handleBack = () => {
        setTimeout(() => navigate('/firmlist'));
    };


    useEffect(() => {
        viewClient(firmId)
    }, [firmId])

    const viewClient = async (firmId) => {
        const input_token = `${firmId}VIEW_FIRM`;
        const apiUrl = 'view_firm'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID,
            id: firmId,
        };
        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                setFormData(prevState => ({
                    ...prevState,
                    userName: data.data.firm_name,
                    owner: data.data.firm_owner_name,
                    designation: data.data.firm_user_designation,
                    registerNumber: data.data.register_number,
                    email: data.data.email,
                    contactNumber: data.data.phone_number,
                    address: data.data.address,
                    country: data.data.locations[0]?.country,
                    zipCode: data.data.locations[0]?.zip_code,
                    state: data.data.locations[0]?.state_name,
                    city: data.data.locations[0]?.city,
                    duration:data.data.duration_in_month +' Month',
                    selectedPlan: data.data.subscription_name,
                    profile_image:data.data.firm_logo,
                    subscription_exp_date:dayjs(data.data.subscription_exp_date).format('MM-DD-YYYY'),
                    profile_image: data.data.firm_logo,
                    subscription_start_date: dayjs(data.data.subscription_start_date).format('MM-DD-YYYY'),
                    PaymentStatus: data.data.payments[0]?.payment_status,
                    paymentType: data.data.payments[0]?.payment_type,
                    paymentDate: dayjs(data.data.payments[0]?.date_of_payment).format("MM/DD/YYYY"),
                    paymentTransaction: data.data.payments[0]?.transaction_number,
                }));
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    }

    return (
        <Box>
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                marginBottom='20px'
                backgroundColor='var(--theme-bg-light)'
                padding={2}
                borderRadius={1}
                className="title_head"
            >
                {/* Left Section */}
                <Box display="flex" alignItems="center">
                    <User style={{ marginRight: 8, fontSize: '12px', color: 'var(--icon-color)' }} />
                    <Typography fontSize={16} color="var(--text-color)">
                    Firm Details
                    </Typography>
                </Box>

                {/* Right Section */}
                <Button
                    variant="outlined"
                    component={Link}
                    to='/firmlist'
                    sx={{
                        backgroundColor: 'var(--back-button)',
                        color: "var(--back-color)",
                        fontWeight: 'bold',
                        border: 'none',
                        padding: '10px 20px'
                    }}
                    startIcon={<ChevronLeft sx={{ fontSize: 17 }} />}
                    style={{ textTransform: 'none' }}
                >
                   Back to Firm list
                </Button>
            </Box>
           <Box className="card-box" sx={{ p: { xs: 2, sm: 2, md: 3 }, m: { xs: 1, sm: 2, md: 3 }, border: '1px solid var(--border-color)', borderRadius: '8px' }}>
            
                 <Box className="sub-header">
                    <Typography sx={{ color: '#3570FF', fontSize: '14px', fontWeight: 'bold' }}>
                    {formData.userName}
                    </Typography>
                    <Typography
                        sx={{ fontWeight: 'bold' }}
                    >
                        Account status: <span sx={{ color: formData.isActive ? 'green' : 'red', backgroundColor: formData.isActive ? 'transparent' : 'red', display: 'inline-block', fontWeight: 'bold' }}>{formData.isActive ? 'Yes' : 'No'}</span>
                    </Typography>
                </Box>


                <Box  >
                    <Grid container spacing={6}>
                        <Grid size={3}>
                            <Typography sx={{ color: '#333', fontSize: '13px', marginBottom: '8px' }}>Firm Full Name :</Typography>
                            <Typography sx={{ fontSize: '14px', color: '#333' }}>{formData.userName}</Typography>
                        </Grid>
                        <Grid size={3}>
                            <Typography sx={{ color: '#333', fontSize: '13px', marginBottom: '8px' }}>Firm User Name :</Typography>
                            <Typography sx={{ fontSize: '14px', color: '#333' }}>{formData.owner}</Typography>
                        </Grid>
                        <Grid size={3}>
                            <Typography sx={{ color: '#333', fontSize: '13px', marginBottom: '8px' }}>Firm User Designation :</Typography>
                            <Typography sx={{ fontSize: '14px', color: '#333' }}>{formData.designation}</Typography>
                        </Grid>

                        <Grid size={3}>
                            <Typography sx={{ color: '#333', fontSize: '13px', marginBottom: '8px' }}>Firm Register Number :</Typography>
                            <Typography sx={{ fontSize: '14px', color: '#333' }}>{formData.registerNumber}</Typography>
                        </Grid>
                        <Grid size={3}>
                            <Typography sx={{ color: '#333', fontSize: '13px', marginBottom: '8px' }}>Firm User Email ID:</Typography>
                            <Typography sx={{ fontSize: '14px', color: '#333' }}>{formData.email}</Typography>
                        </Grid>
                        <Grid size={3}>
                            <Typography sx={{ color: '#333', fontSize: '13px', marginBottom: '8px' }}>Firm User Contact Number:</Typography>
                            <Typography sx={{ fontSize: '14px', color: '#333' }}>{formData.contactNumber}</Typography>
                        </Grid>

                        <Grid size={6}>
                            <Typography sx={{ color: '#333', fontSize: '13px', marginBottom: '8px' }}>Firm Street Address :</Typography>
                            <Typography sx={{ fontSize: '14px', color: '#333' }}>{formData.address}</Typography>
                        </Grid>

                        <Grid size={3}>
                            <Typography sx={{ color: '#333', fontSize: '13px', marginBottom: '8px' }}>Country :</Typography>
                            <Typography sx={{ fontSize: '14px', color: '#333' }}>{formData.country}</Typography>
                        </Grid>
                        <Grid size={3}>
                            <Typography sx={{ color: '#333', fontSize: '13px', marginBottom: '8px' }}>State :</Typography>
                            <Typography sx={{ fontSize: '14px', color: '#333' }}>{formData.state}</Typography>
                        </Grid>
                        <Grid size={3}>
                            <Typography sx={{ color: '#333', fontSize: '13px', marginBottom: '8px' }}>City :</Typography>
                            <Typography sx={{ fontSize: '14px', color: '#333' }}>{formData.city}</Typography>
                        </Grid>
                        <Grid size={3}>
                            <Typography sx={{ color: '#333', fontSize: '13px', marginBottom: '8px' }}>Zip code:</Typography>
                            <Typography sx={{ fontSize: '14px', color: '#333' }}>{formData.zipCode}</Typography>
                        </Grid>

                        <Grid size={3}>
                            <Typography sx={{ color: '#333', fontSize: '13px', marginBottom: '8px' }}>Package Duration</Typography>
                            <Typography sx={{ fontSize: '14px', color: '#333' }}>{formData.duration}</Typography>
                        </Grid>
                        <Grid size={3}>
                            <Typography sx={{ color: '#333', fontSize: '13px', marginBottom: '8px' }}>Subscription Plan :</Typography>
                            <Typography sx={{ fontSize: '14px', color: '#333' }}>{formData.selectedPlan}</Typography>
                        </Grid>

                        <Grid size={3}>
                            <Typography sx={{ color: '#333', fontSize: '13px', marginBottom: '8px' }}>Subscription Joined Date :</Typography>
                            <Typography sx={{ fontSize: '14px', color: '#333' }}>{formData.subscription_start_date}</Typography>
                        </Grid>
                        <Grid size={3}>
                            <Typography sx={{ color: '#333', fontSize: '13px', marginBottom: '8px' }}>Subscription Expired Date code:</Typography>
                            <Typography sx={{ fontSize: '14px', color: '#333' }}>{formData.subscription_exp_date}</Typography>
                        </Grid>
                        <Grid size={3}>
                            <Typography sx={{ color: '#333', fontSize: '13px', marginBottom: '8px' }}>Payment status</Typography>
                            <Typography sx={{ fontSize: '14px', color: '#333' }}>{formData.PaymentStatus}</Typography>
                        </Grid>

                        <Grid size={3}>
                            <Typography sx={{ color: '#333', fontSize: '13px', marginBottom: '8px' }}>Payment ID :</Typography>
                            <Typography sx={{ fontSize: '14px', color: '#333' }}>{formData.paymentTransaction}</Typography>
                        </Grid>
                        <Grid size={3}>
                            <Typography sx={{ color: '#333', fontSize: '13px', marginBottom: '8px' }}>Payment Type:</Typography>
                            <Typography sx={{ fontSize: '14px', color: '#333' }}>{formData.paymentType}</Typography>
                        </Grid>

                        {/* <Grid size={3}>
                        <Typography sx={{ color: '#333', fontSize: '14px', marginBottom: '8px' }}>Is Account Active</Typography>
                        <Typography sx={{ fontSize: '14px', color: '#333' }}>{formData.isAccountActive}</Typography>
                    </Grid>
                    <Grid size={3}>
                        <Typography sx={{ color: '#333', fontSize: '14px', marginBottom: '8px' }}>Next Payment Date</Typography>
                        <Typography sx={{ fontSize: '14px', color: '#333' }}>{formData.nextPaymentDate}</Typography>
                    </Grid> */}

                        <Grid size={3}>
                            <Typography sx={{ color: '#333', fontSize: '13px', marginBottom: '8px' }}>Company Logo</Typography>
                            <Box component="img" src={formData.profile_image} alt="Company Logo" sx={{ width: 100, height: 'auto' }} />
                        </Grid>
                        {/* <Grid size={3}>
                            <Typography sx={{ color: '#333', fontSize: '14px', marginBottom: '8px' }}>Account Username</Typography>
                            <Typography sx={{ fontSize: '14px', color: '#333' }}>{formData.accountUsername}</Typography>
                        </Grid> */}

                        {/* <Grid size={3}>
                            <Typography sx={{ color: '#333', fontSize: '14px', marginBottom: '8px' }}>Login Password</Typography>
                            <Typography sx={{ fontSize: '14px', color: '#333' }}>{formData.loginPassword}</Typography>
                        </Grid> */}
                    </Grid>
                    {/* Action Buttons */}
                    <Box display={'flex'} justifyContent={'center'} gap={2} mt={4}>
                        <Button variant="contained" color="primary" onClick={() => handleClickEdit()}
                            sx={{ padding: '15px 30px', borderRadius: "8px", fontWeight: 'bold', backgroundColor: 'var(--primary-color)', color: '#fff', '&:hover': { backgroundColor: 'var(--primary-color)' } }}

                        >Edit Firm Details</Button>
                        <Button variant="outlined" onClick={() => handleBack()}
                            sx={{ padding: '15px 30px', borderRadius: "8px", fontWeight: 'bold', backgroundColor: 'var(--back-button)',
                                color: "var(--back-color)", '&:hover': { backgroundColor: 'var(--primary-color)', color: '#fff' } }}
                        ><ChevronLeft size={24} /> Back to Firm list</Button>
                    </Box>
                </Box>
            </Box>
        </Box>

    );
}
